export class GetAllInputs {
  maxResultCount: number = 10;
  skipCount: number = 0;
  search: string;
  sortBy: string = 'name asc';
}
